module.exports = __webpack_public_path__ + "img/homepage-quick-links-nissan.49575782.jpg";